import React from 'react';
import {Helmet} from "react-helmet";

//CORE COMPOENTNS
import { ThemeProvider } from '../../../components-core/packages/components-core/dist/theme-provider';
import styled from 'styled-components';
import scroll from '../lead-section/LeadSection'
//LAYOUT
import {
    Container,
    ContainerGutter,
    ContainerWrap,
    ContainerPadding
} from '../../../components-core/packages/components-core/dist/container';
import { Breakpoints } from '../../../components-core/packages/components-core/dist/helpers';

//STYLE
import { Text, TextAppearance } from '../../../components-core/packages/components-core/dist/text';
import { Button, ButtonAppearance } from '../../../components-core/packages/components-core/dist/button'


const FullSizeContainer = styled.div`
    height: 100vh;
    width: 100vw;
`;

const TopContainer = styled.div`
    height: 100vh;
    width: 100vw;
    display: flex;
    align-items: flex-end;
    position: absolute;
    overflow: hidden;

    z-index: 1;

    ${props => props.inverted &&
        `
            background: rgb(0,67,122);
            background: -moz-linear-gradient(325deg, rgba(0,67,122,1) 0%, rgba(0,30,80,1) 100%);
            background: -webkit-linear-gradient(325deg, rgba(0,67,122,1) 0%, rgba(0,30,80,1) 100%);
            background: linear-gradient(325deg, rgba(0,67,122,1) 0%, rgba(0,30,80,1) 100%);
            filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#00437a",endColorstr="#001e50",GradientType=1);
        `
    }
`;

const BackgroundImageContainer = styled.div`
    height: 100vh;
    width: 100vw;
    background-image: url(${props => props.backgroundImageUrl && props.backgroundImageUrl});
    background-position: center;
    background-size: cover;
    background-blend-mode: overlay;
    object-fit: cover;

    ${props => !props.backgroundImageUrl || props.inverted &&
        `
            background: rgb(0,67,122);
            background: -moz-linear-gradient(325deg, rgba(0,67,122,1) 0%, rgba(0,30,80,1) 100%);
            background: -webkit-linear-gradient(325deg, rgba(0,67,122,1) 0%, rgba(0,30,80,1) 100%);
            background: linear-gradient(325deg, rgba(0,67,122,1) 0%, rgba(0,30,80,1) 100%);
            filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#00437a",endColorstr="#001e50",GradientType=1);
        `
    }
`;


const GeneralContainer = styled.div`
    z-index: 1;
    position: relative;
`;

const BackgroundVideo = styled.video`
    height: 100vh;
    width: 100vw;

    object-fit: cover;
`;

/**
 * BannerComponent için tasarımda kullanıldı. 
 * @params
 * backgroundImageUrl (String)
 * inverted (boolean)
 * custom (String): Ana başlık - kalın
 * custom1 (String): Ana başlık - kalın
 * custom2 (String): İkinci başlık - ince
 * custom5 (String): Üçüncü başlık - ince
 */

class TopView extends React.Component {

    constructor() {
        super();
        this.state = {
            isVideoPromo: false
        }
    }

    renderTextContainer() {
        const { custom, custom1, custom2, custom5, inverted } = this.props;

        if (custom2 === 'Hoş geldiniz') {
            return (
                <Container wrap={ContainerWrap.always} >
                    <Text appearance={TextAppearance.headline0300} bold>
                        %100 Yeni %100 Caddy
                    </Text><br />
                    <Button id="#btn" appearance={ButtonAppearance.Primary} style={{ scrollBehaviour: 'true' }}><a href="https://ticariarac.vw.com.tr/yeni-caddy" style={{ textDecoration: 'none' }}><span style={{ color: '#001e50' }}>Hemen Bilgi Al</span></a></Button>
                </Container>
            )
        }
        else if(custom2==='Baştan aşağı yenilendi' || custom1==="Yeni Caddy"){
            return(
                <Container wrap={ContainerWrap.always} >
                <Text appearance={TextAppearance.headline0300} bold>
                <h1>{inverted ? custom : custom1}</h1> 
                </Text>
                <Text appearance={TextAppearance.copy300}>
                    {custom2}
                </Text>
            </Container>
            )

        }
        else if(custom==='Crafter Kredi Kampanyası' || custom1==='Crafter Kredi Kampanyası'){
            return(
                <Container wrap={ContainerWrap.always} >
                <Text appearance={TextAppearance.headline0300} bold>
                <h1>{inverted ? custom : custom1}</h1> 
                </Text>
                <Button id="#btn" appearance={ButtonAppearance.Primary} style={{ scrollBehaviour: 'true' }}><a href="#scroll" style={{ textDecoration: 'none' }}><span style={{ color: '#001e50' }}>Hemen Bilgi Al</span></a></Button>
            </Container>
            )

        }
        else if(custom2 && custom5 && (custom1 || custom)){
            return (
                <Container wrap={ContainerWrap.always} >
                    <Text appearance={TextAppearance.headline0300} bold>
                       <h1>{inverted ? custom : custom1}</h1> 
                    </Text>
                    <Text appearance={TextAppearance.copy300}>
                        {custom2}
                    </Text><br />
                    <Button id="#btn" appearance={ButtonAppearance.Primary} style={{ scrollBehaviour: 'true' }}><a href="#scroll" style={{ textDecoration: 'none' }}><span style={{ color: '#001e50' }}>Hemen Teklif Al</span></a></Button>
                </Container>
            )
        }
        else  {
            return( <Container wrap={ContainerWrap.always} >
                <Text appearance={TextAppearance.headline0300} bold>
                <h1>{inverted ? custom : custom1}</h1> 
                </Text>
                <Text appearance={TextAppearance.copy300} bold>
                    {custom2}
                </Text>
            </Container>)
        
        }

    }

    renderVideoBackground() {
        return (
            <FullSizeContainer>
                <BackgroundVideo autoPlay muted loop>
                    <source src="https://s7g10.scene7.com/is/content/volkswagenag/Video_home_v4.1-0x720-3000k" type="video/mp4" />
                </BackgroundVideo>
            </FullSizeContainer>

        )
    }

    render() {

        const { custom4, custom6, noButton, custom7, inverted } = this.props;
        const backgroundImageUrl = custom7;

        return (
            <ThemeProvider theme={'image'}>
                <GeneralContainer>
                    <TopContainer inverted={inverted} >
                        <Container
                            wrap={ContainerWrap.always}
                            padding={containerPadding}
                            gutter={ContainerGutter.dynamic0200}
                        >
                            {this.renderTextContainer()}
                            {
                                !noButton || !custom6 &&
                                <Button appearance={ButtonAppearance.Primary}>
                                    {custom4 ? custom4 : 'Hemen Keşfet'}
                                </Button>
                            }
                        </Container>
                    </TopContainer>
                </GeneralContainer>

                {
                    this.state.isVideoPromo ?
                        this.renderVideoBackground() :
                        <BackgroundImageContainer
                            inverted={inverted}
                            backgroundImageUrl={backgroundImageUrl ? backgroundImageUrl : null}
                        />
                }
            </ThemeProvider>
        )
    }
}

const containerPadding = {
    left: {
        [Breakpoints.default]: ContainerPadding.dynamic0200,
        [Breakpoints.b560]: ContainerPadding.dynamic0250,
        [Breakpoints.b960]: ContainerPadding.dynamic0350
    },
    right: ContainerPadding.dynamic0300,
    bottom: {
        [Breakpoints.default]: ContainerPadding.dynamic0350,
        [Breakpoints.b560]: ContainerPadding.dynamic0450
    }
}


export default TopView;